import { useOpMutation } from '../useOpMutation';

export const useGetSsoAuthUrl = () => {
  return useOpMutation({
    apiEndpointName: 'getSsoAuthUrl',
    shouldSuppressErrorMessage: (error) =>
      error.statusCode === 401 && error.message === 'Namespace is required.',
  });
};
